<template>
  <div class="video-page" @touchmove="touchmove">
    <meta name="referrer" content="never" />
    <template v-if="[1, 2, 3, 4, 5].includes(data.info?.isExpired)">
      <div class="masker"></div>
      <div class="expire-card">
        <div class="center">
          <div class="title">{{ linkStautsInfo.title }}</div>
          <div class="desc">{{ linkStautsInfo.desc }}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- 登录 -->
      <template v-if="data.isLogin && data.auditStatus === 1">
        <!-- 答题状态 -->
        <!-- 失败 -->
        <div class="finish-page fail" v-if="answerStatus === 2 && !isContinue">
          <img src="../../assets/answer-failed.png" alt="">
          <div class="title">回答错误</div>
          <div class="text-center">
            <div class="desc w112">3次机会已用光 请下次再接再厉吧</div>
          </div>
        </div>
        <template v-else>
          <div class="video-section">
            <div class="top-userInfo">
              <div class="flex-start">
                <img class="avatar" :src="data.userInfo.avatar" />
                <div>
                  <div class="nickname">{{ data.userInfo.nickname }}</div>
                  <div class="userId">ID: {{ data.info.id }}</div>
                </div>
              </div>
              <div class="copyLink"
                @click="clickCopy"
                :data-clipboard-text="data.info.id">
                复制
              </div>
            </div>
            <div class="video-box">
              <video
                id="courseVideo"
                playsinline 
                webkit-playsinline
                :src="data.info?.url"
                :poster="data.info?.cover"
                :controls="false"
              >
              </video>
              <div class="remain-time">{{ data.videoDuration }}</div>
              <img class="play-icon" src="../../assets/play_icon.png" alt="" v-if="!isPlay" @click="onVideoPlay">
              <img class="fullscreen" src="../../assets/fullscreen.png" alt="" @click="onFullScreen">
            </div>
            <div class="title">{{ data.info?.title }}</div>
            <div class="create-time">截止时间：{{ data.info.endTime?.replace("T", " ") }}</div>
          </div>
          <div class="answer-section">
            <div class="header" v-if="!data.info.isReward && !data.info.isAnswer">
              <img class="money" src="../../assets/money.png" alt="">
              <div>本次答题红包：{{ data.info.rewardNum }}元</div>
            </div>
            <div class="content">
              <div class="question">问题：{{ data.questionInfo.content }} ({{ data.questionInfo.type === 'single' ? '单选题' : '多选题' }})</div>
              <div class="answer-list">
                <div class="answer-item" 
                  v-for="(item, index) in data.questionInfo.answer || []" :key="item.answerId" 
                  :class="{ 
                    active: selectAnswerIds.includes(item.answerId),
                    fail: selectAnswerIds.includes(item.answerId) && answerStatus === 2 
                  }" 
                  @click="onTabItemClick(item)"
                >
                  <span class="text-ellipsis">{{ data.options[index] }}. {{ item.answerContent }}</span>
                  <template v-if="answerStatus === 1">
                    <img class="checked" src="../../assets/success.png" alt="" v-if="selectAnswerIds.includes(item.answerId)">
                  </template>
                  <template v-else-if="answerStatus === 2">
                    <img class="checked" src="../../assets/fail.png" alt="" v-if="selectAnswerIds.includes(item.answerId)">
                  </template>
                  <template v-else>
                    <img class="checked" src="../../assets/checked.png" alt="" v-if="selectAnswerIds.includes(item.answerId)">
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="control-box">
            <div class="submit-btn" v-if="[0, 1].includes(answerStatus)" :class="{ disabled: selectAnswerIds.length === 0 || !data.isPlayFinish }" @click="onSubmitClick">{{ answerStatus === 1 ? '回答正确': '提交回答' }}</div>
            <div class="submit-btn fail" v-else @click="onRefreshClick">
              <img class="refresh" src="../../assets/refresh.png" alt="">
              <span>回答错误，点击重新作答</span>
            </div>
          </div>
          <!-- <div class="version">
            <div class="version-row" @click="onClickHandler">---</div>
            <div class="version-row" v-if="data.isShowVersion">视频时长：{{ data.duration }} {{ data.currentTime }} {{ data.videoDuration }}</div>
          </div> -->
        </template>
      </template>
      <template v-else>
        <template v-if="!data.isLogin && data.isLoading">
          <div class="loading-card">
            <van-loading size="50px" color="#3478F6" vertical>加载中...</van-loading>
          </div>
        </template>
        <template v-else>
          <div class="masker"></div>
          <div class="apply-card" :class="{ 'black-card': data.auditStatus === 2 }" v-if="data.isLogin && [0, 2].includes(data.auditStatus)">
            <div class="center">
              <div class="title">
                <template v-if="data.auditStatus === 0">已提交申请</template>
                <template v-else-if="data.auditStatus === 2">您已被关进小黑屋</template>
              </div>
              <div class="desc">
                <template v-if="data.auditStatus === 0">请联系客服审核</template>
                <template v-else-if="data.auditStatus === 2">请联系客服解除限制</template>
              </div>
              <div class="user-info">
                <img class="avatar" :src="data.userInfo.avatar" alt="">
                <div class="nickname">{{ data.userInfo.nickname }}</div>
              </div>
            </div>
          </div>
          <template v-else>
            <div class="loading-card" v-if="!data.info?.title">
              <van-loading size="50px" color="#3478F6" vertical>加载中...</van-loading>
            </div>
            <div class="video-card" v-else>
              <img :src="data.info.cover" alt="">
              <div class="title">{{ data.info.title }}</div>
              <div class="learn-btn" @click="handleLogin">去学习</div>
            </div>
          </template>
        </template>
      </template>
    </template>
    <div class="masker" v-show="data.isShowRemarkDialog"></div>
    <div class="remark-dialog" v-show="data.isShowRemarkDialog">
      <div class="title">设置备注</div>
      <img class="avatar" :src="data.userInfo.avatar" />
      <div class="nickname">{{ data.userInfo.nickname }}</div>
      <div class="form">
        <div class="form-item2">
          <div class="text">电话：</div>
          <input class="input" v-model="data.phone" type="tel" maxlength="11" placeholder="请填写电话">
        </div>
      </div>
      <div class="flex-center">
        <div class="btn-item save-btn" @click="onRemarkConfirm">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { defineComponent, reactive, watch, ref, onMounted, computed } from "vue"; 
import { userApply, getVideoInfo, getQuestion, getUnAuthVideoInfo, submitAnswer, saveCustomerPhone, checkCustomer } from "@/request/course";
import { wxLogin } from "@/request";
import { getStorage, setStorage, removeStorage } from "../../utils/auth.js";
import { Toast } from "vant";
import { useCustomVideoPlayer } from './useVideoTimeTracker';
import { H5URL } from '../../config'
import ClipboardJS from 'clipboard'

export default defineComponent({
  name: "videoWatch",
  setup() {
    const router = useRouter();
    let query = router.currentRoute.value.query;
    console.log("query: ", query);

    const data = reactive({
      info: {},
      userInfo: {},
      isLogin: !!getStorage("info"),
      auditStatus: null, // 0审核中 1审核通过 2黑名单
      isPlayFinish: false,
      questionInfo: {},
      options: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "G", "K", "L"],
      isLoading: false,
      videoDuration: "",
      duration: '',
      currentTime: '',
      username: "",
      phone: '',
      isShowRemarkDialog: false,
      isShowVersion: false,
    });

    const statusMap = {
      1: { title: '链接已过期', desc: '请联系客服了解详情' },
      2: { title: '课程已结束', desc: '请联系客服了解详情' },
      3: { title: '暂无权限', desc: '请联系其他同事' },
      4: { title: '课程未开始', desc: '请联系客服了解详情' },
      5: { title: 'CDN流量已用完', desc: '请联系客服了解详情' }
    }
    const linkStautsInfo = computed(() => {
      return statusMap[data.info?.isExpired] || {};
    });

    // 获取视频信息
    const getVideoDetailInfo = async () => {
      try {
        const res = await getVideoInfo(query.key);
        console.log('获取视频信息：', res)
        if (res.code === 200) {
          data.info = { ...res.data }
          if (data.info?.watchTime >= data.info?.realTime) {
            data.isPlayFinish = true;
          }
        }
        const videoId = res.data.vid;
        if (videoId) {
          getQuestion(videoId).then(res => {
            data.questionInfo = res.data || {};
          });
        }
        // 答题完成，检测是否添加手机号
        if (data.info?.isAnswer == 1 && data.info?.isReward == 0) {
          checkPhoneIsAdd();
        }
      } catch (error) {
        console.log('请求出错：', error);
      }
    }

    const checkPhoneIsAdd = async () => {
      const res = await checkCustomer({
        relId: data.info.relId
      });
      console.log(res);
      if (res.code === 200) {
        redPackOrderInfo.value = res.data.redPackOrderInfo || {};
        if (!res.data.checkCustomer) {
          data.isShowRemarkDialog = true;
        } else {
          goRedPacketPage();
        }
      }
    }

    // 用户申请
    const applyUserHandle = () => {
      userApply({
        sourceUid: query.uid,
        sourceCompanyId: query.companyId
      }).then(res => {
        data.auditStatus = res.data.status;
        data.userInfo = {
          nickname: res.data.targetUserName,
          avatar: res.data.targetHeadimage
        }
        if (data.auditStatus === 1) {
          getVideoDetailInfo();
          new ClipboardJS(".copyLink");
        }
      })
    }

    watch(() => data.isLogin, (newValue) => {
      if (!newValue) return;
      applyUserHandle();
    }, { immediate: true });


    onMounted(async () => {
      document.title = '学习中心';
      try {
        JSON.parse(getStorage("info"))
      } catch (error) {
        removeStorage("info")
        window.location.reload()
      }
      if (query.code && !getStorage("info")) {
        data.isLoading = true;
        try {
          const info = await wxLogin({
            code: query.code,
            JSurl: `${H5URL}?code=${query.code}&state=123`,
            uid: null,
          });
          setStorage("info", JSON.stringify(info));
          data.isLoading = false;
          data.isLogin = true;
        } catch (err) {
          console.log(err);
          data.isLoading = false;
        }
      }

      // 获取视频信息
      if (!getStorage("info")) {
        const videoInfo = await getUnAuthVideoInfo(query.key);
        console.log(videoInfo);
        if (videoInfo.code === 200) {
          data.info = { ...videoInfo.data }
        }
      }
    })

    const handleLogin = () => {
      window.location.href = `${H5URL}/redirect${location.search}&redirect=${location.origin}`;
    };

    const touchmove = (e) => {
      if (!data.isLogin || data.isShowRemarkDialog) {
        e.preventDefault();
      }
    };

    const { isPlay, onVideoPlay, onFullScreen } = useCustomVideoPlayer('#courseVideo', data)

    const selectAnswerIds = ref([]);
    const isContinue = ref(1);
    const answerStatus = ref(0); // 1 成功 2：失败
    const redPackOrderInfo = ref({});
    const onTabItemClick = (item) => {
      if (answerStatus.value !== 0) return;
      if (data.questionInfo.type === 'single') {
        selectAnswerIds.value = [item.answerId];
      } else {
        if (selectAnswerIds.value.includes(item.answerId)) {
          const index = selectAnswerIds.value.findIndex(it => it === item.answerId);
          selectAnswerIds.value.splice(index, 1);
        } else {
          selectAnswerIds.value.push(item.answerId);
        }
      }
    }


    const goRedPacketPage = () => {
      const { state, msg, ...p } = redPackOrderInfo.value;
      if (state === 'ERROR') return Toast(msg);
      const searchParams = new URLSearchParams(window.location.search);
      const key = searchParams.get("key");
      const companyId = searchParams.get("companyId");
      const uid = searchParams.get("uid");
      const params = { 
        ...p, 
        rewardNum: data.info.rewardNum, 
        redirect: location.origin,
        key,
        companyId,
        uid
      }
      const str = Object.keys(params).reduce((p, c) => `${p}${c}=${encodeURIComponent(params[c])}&`, '');
      window.location.href = `${H5URL}/redPacket?${str}`;
    }

    const onSubmitClick = async () => {
      if (!selectAnswerIds.value.length || !data.isPlayFinish) return;
      if (answerStatus.value == 1) return;
      const { id: questionId } = data.questionInfo;
      const res = await submitAnswer({
        relId: data.info.relId, // 课程Id
        questionId,
        optionIds: selectAnswerIds.value
      });
      console.log('提交答案：', res);
      if (res.code === 200) {
        if (res.data.isCorrect === 1) {
          answerStatus.value = 1;
          redPackOrderInfo.value = res.data.redPackOrderInfo;
          if (!data.info.isAnswer && res.data.isReward == 0) { // 答题完成未填写备注
            data.isShowRemarkDialog = true;
          } else if (!data.info.isReward && res.data.isReward == 1) { // 答题完成未领取红包
            goRedPacketPage();
            // Toast('答题正确');
          }
          return;
        }
        isContinue.value = res.data.isContinue;
        answerStatus.value = 2;
      }
    }

    const onRefreshClick = () => {
      answerStatus.value = 0;
      selectAnswerIds.value = [];
    }

    const onRemarkConfirm = async () => {
      if (!data.phone) {
        return Toast('请填写手机号');
      }
      let reg = /^[1][3-9][0-9]{9}$/;
      if (!reg.test(data.phone)){
        return Toast('手机号格式不正确');
      }
      const res = await saveCustomerPhone({
        relId: data.info.relId,
        customerPhone: data.phone,
      });
      if (res.code === 200) {
        data.isShowRemarkDialog = false;
        goRedPacketPage();
        // Toast("提交成功");
      }
    }

    const onClickHandler = () => {
      data.isShowVersion = !data.isShowVersion;
    }

    const clickCopy = () => {
      Toast('复制成功');
    }

    return {
      touchmove,
      data,
      linkStautsInfo,
      query,
      handleLogin,
      isPlay,
      onVideoPlay,
      onFullScreen,
      isContinue,
      answerStatus,
      selectAnswerIds,
      onTabItemClick,
      onRefreshClick,
      onSubmitClick,
      onRemarkConfirm,
      onClickHandler,
      clickCopy
    };
  },
  beforeUnmount() {
    window.removeEventListener("scroll", () => {});
  },
});
</script>

<style lang="scss" scope>
html,
body,
#app {
  height: 100%;
}

.video-page {
  position: relative;
  height: 100vh;
  background-color: #F7F7F7;
  overflow-y: auto;

  .version {
    margin-top: 30px;
    text-align: center;

    .version-row {
      margin-bottom: 10px;
    }
  }
}

.video-section {
  padding: 20px 15px;
  background-color: #fff;
  margin-bottom: 8px;

  .top-userInfo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .avatar {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .nickname, .userId {
      font-size: 14px;
    }

    .copyLink {
      color: #3478F6;
      font-size: 14px;
    }
  }

  .video-box {
    position: relative;
    width: 100%;
    height: 210px;
    background-color: #000;
  }

  #courseVideo {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;

    &::--webkit-media-controls {
      display: none!important;
    }
  }

  .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 60px;
    height: 60px;
  }

  .fullscreen {
    position: absolute;
    right: 10px;
    bottom: 10px;
    width: 30px;
    height: 30px;
  }

  .remain-time {
    position: absolute;
    top: 15px;
    right: 15px;
    color: #333333;
    font-size: 18px;
  }

  .title {
    font-weight: bold;
    font-size: 16px;
    line-height: 28px;
    color: #333333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 4px;
    margin-top: 12px;
  }

  .create-time {
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    line-height: 17px;
  }
}

.answer-section {
  background-color: #fff;

  .header {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    border-bottom: 1px solid #F2F2F4;
    color: #EA5427;
    font-size: 14px;
    line-height: 20px;

    .money {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }

  .content {
    padding: 20px 15px;

    .question {
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      font-weight: bold;
      margin-bottom: 12px;
    }

    .answer-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 40px;
      padding: 0 12px;
      box-sizing: border-box;
      background: #F5F7FA;
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      overflow: hidden;

      .checked {
        width: 14px;
        height: 14px;
      }

      .text-ellipsis {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      &:not(:last-of-type) {
        margin-bottom: 4px;
      }

      &.active {
        background-color: #DCE7FA;
        color: #3478F6;
        font-weight: bold;
      }

      &.fail {
        background-color: #FFE6DD;
        color: #EA5427;
      }
    }
  }
}

.control-box {
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  padding-bottom: 20px;

  .submit-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 34px;
    background: #3478F6;
    border-radius: 17px 17px 17px 17px;
    text-align: center;
    line-height: 34px;
    color: #fff;

    .refresh {
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }

    &.disabled {
      background: rgba(52, 120, 246, .6)
    }

    &.fail {
      background: #EA5427;
    }
  }
}

.answer-placeholder {
  width: 100%;
  height: 44px;
  font-size: 14px;
  color: #666666;
  line-height: 44px;
  text-align: center;
  background-color: #fff;
}

.masker {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, .5);
}

.video-card {
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  width: 289px;
  height: 302px;
  background: #FAFBFC;
  border-radius: 20px 20px 20px 20px;
  padding: 32px 20px;
  box-sizing: border-box;

  img {
    width: 249px;
    height: 152px;
    display: block;
    margin-bottom: 8px;
    object-fit: cover;
  }

  .title {
    font-size: 14px;
    color: #333333;
    text-align: center;
    margin-bottom: 32px;
  }

  .learn-btn {
    width: 249px;
    height: 34px;
    background: #3478F6;
    border-radius: 17px 17px 17px 17px;
    color: #fff;
    text-align: center;
    line-height: 34px;;
  }

}

.apply-card {
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  width: 299px;
  height: 345px;
  background: url(../../assets/apply-dialog.png) no-repeat;

  &.black-card {
    background-image: url(../../assets/black-dialog.png);
  }

  .center {
    position: absolute;
    top: 140px;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
  }

  .title {
    font-size: 26px;
    color: #333;
    font-weight: bold;
    text-align: center;
  }

  .desc {
    font-size: 14px;
    color: #333333;
    line-height: 21px;
    text-align: center;
    margin-top: 4px;
  }

  .user-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 24px;

    .avatar {
      width: 55px;
      height: 55px;
      box-shadow: 0px 3px 6px 1px rgba(91,116,165,0.16);
      border: 3px solid #FFFFFF;
      border-radius: 50%;
    }

    .nickname {
      font-size: 16px;
      color: #333333;
      line-height: 21px;
      text-align: center;
      margin-top: 8px;
      font-weight: bold;
    }
  }
}

.expire-card {
  position: absolute;
  left: 50%;
  top: 45%;
  transform: translate(-50%, -50%);
  width: 299px;
  height: 265px;
  background: url(../../assets/expire-dialog.png) no-repeat;

  .center {
    position: absolute;
    top: 156px;
    left: 50%;
    transform: translateX(-50%);
  }

  .title {
    font-size: 26px;
    color: #333;
    font-weight: bold;
    text-align: center;
    white-space: nowrap;
  }

  .desc {
    font-size: 14px;
    color: #333333;
    line-height: 21px;
    text-align: center;
    margin-top: 4px;
  }
}

.finish-page {
  text-align: center;

  img {
    width: 100%;
    display: block;
  }

  .title {
    font-size: 20px;
    color: #333;
    text-align: center;
    margin-top: 32px;
  }

  .text-center {
    display: flex;
    justify-content: center;
  }

  .desc {
    max-width: 210px;
    font-size: 14px;
    color: #333333;
    line-height: 21px;
    text-align: center;
    margin-top: 8px;

    &.w112 {
      max-width: 112px;
    }
  }
}

.loading-card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.flex-center,
.flex-start {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.flex-start {
  justify-content: flex-start;
}

.remark-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 295px;
  height: 330px;
  // height: 398px;
  background-color: #FFFFFF;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    font-size: 16px;
    color: #333333;
    margin: 24px 0;
  }
  
  .avatar {
    width: 42px;
    height: 42px;
    margin-bottom: 6px;
    border-radius: 50%;
    overflow: hidden;
  }
  
  .nickname {
    font-size: 14px;
    color: #333;
  }
  
  .form {
    width: 265px;
    margin-top: 44px;
  }
  
  .form-item {
    margin-bottom: 12px;
  }
  
  .form-item2 {
    margin-bottom: 32px;
  }
  
  .text {
    font-size: 12px;
    color: #666;
    margin-bottom: 6px;
  }
  
  .input {
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;
    height: 36px;
    background-color: #EDF2FA;
    border-radius: 4px;
    color: #333333;
    font-size: 14px;
    border: none;
  }
  
  .btn-item {
    height: 34px;
    background: #FFFFFF;
    border-radius: 17px;
    padding: 0 50px;
    border: 1px solid #446CE2;
    text-align: center;
    line-height: 34px;
    color: #3478F6;
    font-size: 13px;
  }
  
  .save-btn {
    background: #3478F6;
    color: #fff;
    // margin-left: 13px;
  }
}

.redPacket {
  width: 100%;
  height: 449px;
  position: relative;
  margin-top: 15px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .money-center {
    position: absolute;
    top: 132px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    color: #EA5427;

    .money-text {
      font-size: 64px;
      line-height: 70px;
      font-weight: bold;
      margin-right: 8px;
    }

    .unit {
      position: relative;
      bottom: -10px;
      font-size: 24px;
      line-height: 70px;
    }
  }

  .money-tips {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 270px;
    width: 210px;
    height: 42px;
    font-weight: 400;
    font-size: 14px;
    color: #FDF4BC;
    line-height: 22px;
    text-align: center;
  }

  .collect-money {
    position: absolute;
    top: 328px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 23px;
    line-height: 22px;
    color: #FAE14D;
    text-align: center;
  }
}
</style>
